import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import SM from '../services/ServiceManager';

export const useSchemaFields = (schemaFiled) => {
    const { i18n: { language }, t } = useTranslation();

    const { data, isLoading, error } = useQuery({
        queryKey: ['getSchemaFields', schemaFiled, language],
        queryFn: async () => {
            const { data } = await SM.clientService('getSchemaFields', [schemaFiled]);

            data?.fields?.forEach((field) => { field.label = t(`dynamicCRM.${field.key}`); });

            return data;
        },
        enabled: !!schemaFiled,
        staleTime: 1000 * 60 * 5, // 5 minutes
        gcTime: 1000 * 60 * 10, // 10 minutes
    });

    return { data: data ?? null, isLoading, error: error ?? null };
};
